/**
 * Known feature flag keys. Use these instead of string literals so keys stay in sync with LaunchDarkly.
 */
export enum FeatureFlagKey {
  ENABLEFAAPP = 'enableFAApp',
  ENABLEASKNAVI = 'enableAskNavi',
  ENABLEFINANCIALSNAPSHOT = 'enableFinancialSnapshot',
  /** FA Review tab (`air-review-queue`). Off by default until LaunchDarkly is wired. */
  ENABLEAIREVIEW = 'enableAiReview',
}
